let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("j0PWv"), load("eBoC7"), load("ksTQ6"), load("63R0Y")]).then(() => parcelRequire('c6G0e'));